import InputWithTag from './InputWithTags';

export default InputWithTag;
